import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import { CompletePageConditionalRuleModel } from '@/domain/model/forms'

export const updateCompletePageConditionalRules = async (
  data: Omit<CompletePageConditionalRuleModel, 'is_new'>
): Promise<void> => {
  return makePatchRequest(ApiBase + `/workflows/redirect-rules/${data.id}`, {
    body: JSON.stringify(data),
  })
}
